import { IconComponentWrapper } from "../scripts/generate-icons/icon-component-wrapper";
import type { IconProps } from "../scripts/generate-icons/ticon-component-wrapper";

function IconComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={36}
      height={24}
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_820_26445)">
        <rect width={36} height={24} fill="white" />
        <path
          d="M15.6709 17.6413L15.8915 16.2401L15.4001 16.2286H13.0532L14.6842 5.88844C14.6891 5.85722 14.7057 5.82811 14.7297 5.80745C14.7538 5.78678 14.7846 5.77539 14.8167 5.77539H18.7738C20.0875 5.77539 20.9941 6.04873 21.4675 6.58824C21.6893 6.84134 21.8307 7.10582 21.8991 7.39688C21.9707 7.70229 21.972 8.06717 21.902 8.5122L21.8969 8.54468V8.82982L22.1189 8.95554C22.3058 9.05466 22.4542 9.16813 22.5681 9.29805C22.758 9.51445 22.8808 9.78948 22.9326 10.1155C22.9862 10.4509 22.9685 10.8499 22.8808 11.3017C22.7795 11.8214 22.6158 12.274 22.3948 12.6444C22.1914 12.9857 21.9323 13.2686 21.6249 13.4881C21.3312 13.6964 20.9823 13.8546 20.5879 13.9559C20.2056 14.0554 19.7698 14.1056 19.2919 14.1056H18.9839C18.7637 14.1056 18.5497 14.1849 18.3819 14.3271C18.2136 14.4722 18.1021 14.6704 18.068 14.8872L18.0448 15.0134L17.655 17.4831L17.6372 17.5738C17.6326 17.6026 17.6246 17.6169 17.6128 17.6266C17.6023 17.6354 17.5871 17.6413 17.5723 17.6413H15.6709Z"
          fill="#253B80"
        />
        <path
          d="M22.328 8.57812C22.3162 8.65363 22.3027 8.73082 22.2876 8.81012C21.7656 11.4891 19.9803 12.4146 17.7 12.4146H16.5391C16.2602 12.4146 16.0252 12.6171 15.9818 12.8921L15.3873 16.6616L15.219 17.73C15.1907 17.9106 15.33 18.0734 15.5122 18.0734H17.5714C17.8153 18.0734 18.0223 17.8963 18.0607 17.6558L18.081 17.5512L18.4687 15.0911L18.4936 14.9562C18.5315 14.7149 18.7391 14.5377 18.9829 14.5377H19.2909C21.2859 14.5377 22.8478 13.7278 23.3043 11.3841C23.4949 10.405 23.3962 9.58755 22.8916 9.0126C22.739 8.83923 22.5495 8.69539 22.328 8.57812Z"
          fill="#179BD7"
        />
        <path
          d="M21.7813 8.35916C21.7016 8.33596 21.6193 8.31487 21.5349 8.29589C21.4501 8.27733 21.3632 8.26088 21.2738 8.24654C20.9607 8.19592 20.6178 8.17188 20.2503 8.17188H17.1487C17.0723 8.17188 16.9998 8.18917 16.9349 8.22038C16.7918 8.28914 16.6856 8.42455 16.6598 8.59032L15.9999 12.7689L15.981 12.8908C16.0244 12.6158 16.2594 12.4133 16.5382 12.4133H17.6992C19.9795 12.4133 21.7649 11.4874 22.2868 8.80883C22.3023 8.72953 22.3154 8.65233 22.3272 8.57683C22.1952 8.50681 22.0521 8.44691 21.8981 8.39586C21.8602 8.38321 21.821 8.37098 21.7813 8.35916Z"
          fill="#222D65"
        />
        <path
          d="M16.6613 8.59138C16.6871 8.4256 16.7934 8.2902 16.9364 8.22186C17.0018 8.19064 17.074 8.17335 17.1502 8.17335H20.2519C20.6194 8.17335 20.9624 8.19739 21.2753 8.24801C21.3648 8.26235 21.4518 8.27881 21.5365 8.29736C21.6209 8.31635 21.7032 8.33744 21.7829 8.36064C21.8225 8.37245 21.8618 8.38468 21.9001 8.39692C22.0541 8.44795 22.1972 8.50828 22.3292 8.57788C22.4845 7.58786 22.328 6.91378 21.7927 6.30339C21.2025 5.63143 20.1372 5.34375 18.7741 5.34375H14.8169C14.5384 5.34375 14.301 5.54622 14.2579 5.82167L12.6097 16.2682C12.5772 16.4748 12.7366 16.6614 12.945 16.6614H15.3881L16.0015 12.77L16.6613 8.59138Z"
          fill="#253B80"
        />
      </g>
      <rect x={0.5} y={0.5} width={35} height={23} stroke="#E2E8F0" />
      <defs>
        <clipPath id="clip0_820_26445">
          <rect width={36} height={24} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
const IconComponentWrapped = (props: IconProps) => {
  return (
    <IconComponentWrapper data-testid="icon-paypal" {...props}>
      <IconComponent />
    </IconComponentWrapper>
  );
};
export default IconComponentWrapped;
